import React, { useState, useEffect } from 'react';
import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import Brief from '../components/Brief';
import Counterparty from '../components/Counterparty';
import Contracts from '../components/Contracts';
import Notifications from '../components/Notifications';
import Sources from '../components/Sources';
import Settings from '../components/Settings';
import Onboarding from '../components/Onboarding';
import OneTime from '../components/OneTime';
import Analytics from '../components/Analytics';
import LawUpdates from '../components/LawUpdates';
import S1Invoices from '../components/S1Invoices';
import BankGuarantees from '../components/BankGuarantees';
import Tenders from '../components/Tenders';
import Accounting from '../components/Accounting';
import Warehouse from '../components/Warehouse';
import Production from '../components/Production';
import BankAccounts from '../components/BankAccounts';
import AIChat from '../components/AIChat';
import Feedback from '../components/Feedback';
import Tariffs from '../components/Tariffs';
import { canAccess } from '../checkPlan';

function Dashboard({ onLogout }) {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('khepri_user') || '{}');
  const [showOnboarding, setShowOnboarding] = useState(!localStorage.getItem('onboarding_done'));
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const finishOnboarding = () => {
    localStorage.setItem('onboarding_done', '1');
    setShowOnboarding(false);
  };

  const menuItems = [
    { to: '/', label: 'Сегодня', hint: 'Главный экран с балансом и задачами' },
    { to: '/counterparty', label: 'Контрагенты', access: 'counterparty', hint: 'Проверка контрагентов по ИНН' },
    { to: '/contracts', label: 'Договоры', access: 'contracts', hint: 'Генерация договоров и подпись УКЭП' },
    { to: '/notifications', label: 'Уведомления', access: 'notifications', hint: 'Уведомления о налогах и рисках' },
    { to: '/tenders', label: 'Тендеры', hint: 'Госзакупки и казначейские счета' },
    { to: '/guarantees', label: 'Гарантии', hint: 'Банковские гарантии для тендеров' },
    { to: '/s1', label: '1С', hint: 'Интеграция с 1С:Бухгалтерия' },
    { to: '/law-updates', label: 'Законы', hint: 'Обновления налогового законодательства' },
    { to: '/one-time', label: 'Сервисы', hint: 'Разовые услуги: аудит, проверка договоров' },
    { to: '/accounting', label: '📊 Налоги', hint: 'Налоговый калькулятор и декларация' },
    { to: '/warehouse', label: '🏭 Склад', hint: 'Учёт запасов и закупок' },
    { to: '/production', label: '⚙️ Производство', hint: 'Управление производством (ERP)' },
    { to: '/sources', label: 'Источники', access: 'sources', hint: 'Подключённые банки и сервисы' },
    { to: '/settings', label: 'Настройки', access: 'settings', hint: 'Налоговый режим и параметры' },
    { to: '/analytics', label: 'Аналитика', hint: 'Метрики и оценка бизнеса' },
    { to: '/bankaccounts', label: 'Банки', hint: 'Открытие счёта, сравнение банков' },
    { to: '/aichat', label: '🤖 ИИ-чат', hint: 'ИИ-Ко-фаундер отвечает на вопросы' },
    { to: '/tariffs', label: '💳 Тарифы', hint: 'Выбор плана подписки' },
    { to: '/feedback', label: '📮 Обратная связь', hint: 'Сообщить об ошибке или предложить идею' },
  ];

  const filteredMenu = menuItems.filter(item => {
    if (item.access && !canAccess(item.access)) return false;
    return item.label.toLowerCase().includes(searchQuery.toLowerCase()) ||
           item.hint.toLowerCase().includes(searchQuery.toLowerCase());
  });

  if (showOnboarding) {
    return <Onboarding onDone={finishOnboarding} />;
  }

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 16px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px 0', borderBottom: '1px solid #8A6636', marginBottom: 16, gap: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              display: 'none',
              background: '#1E293B',
              border: '1px solid #8A6636',
              borderRadius: 8,
              color: '#F7DE8A',
              fontSize: 20,
              padding: '8px 12px',
              cursor: 'pointer',
            }}
            className="hamburger"
          >
            ☰
          </button>
          <span style={{ fontSize: 22, fontWeight: 700, color: '#F7DE8A' }}>Khepri</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
          <input
            value={searchQuery}
            onChange={e => setSearchQuery(e.target.value)}
            placeholder="🔍 Поиск по меню..."
            style={{
              padding: '8px 16px',
              background: '#0F172A',
              border: '1px solid #8A6636',
              borderRadius: 20,
              color: '#F8FAFC',
              fontSize: 13,
              width: 200,
              maxWidth: '100%',
            }}
          />
          <span style={{ color: '#94A3B8', fontSize: 14, cursor: 'pointer' }} title="Профиль пользователя">
            {user.name || 'Пользователь'}
          </span>
          <button onClick={() => { onLogout(); navigate('/login'); }} style={{ background: '#8A6636', color: '#F8FAFC', border: 'none', padding: '8px 16px', borderRadius: 6, cursor: 'pointer' }}>Выйти</button>
        </div>
      </header>

      <nav style={{ display: menuOpen ? 'flex' : 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap', background: menuOpen ? '#1E293B' : 'transparent', padding: menuOpen ? 12 : 0, borderRadius: 8 }}>
        {filteredMenu.map((item, i) => (
          <Link
            key={i}
            to={item.to}
            title={item.hint}
            onClick={() => setMenuOpen(false)}
            style={{ padding: '8px 16px', background: '#1E293B', borderRadius: 8, color: '#94A3B8', textDecoration: 'none', border: '1px solid #8A6636', cursor: 'pointer' }}
          >
            {item.label}
          </Link>
        ))}
        {filteredMenu.length === 0 && (
          <span style={{ color: '#94A3B8', fontSize: 13 }}>Ничего не найдено</span>
        )}
      </nav>

      <Routes>
        <Route path="/" element={<Brief />} />
        {canAccess('counterparty') && <Route path="/counterparty" element={<Counterparty />} />}
        {canAccess('contracts') && <Route path="/contracts" element={<Contracts />} />}
        {canAccess('notifications') && <Route path="/notifications" element={<Notifications />} />}
        <Route path="/tenders" element={<Tenders />} />
        <Route path="/guarantees" element={<BankGuarantees />} />
        <Route path="/s1" element={<S1Invoices />} />
        <Route path="/law-updates" element={<LawUpdates />} />
        <Route path="/one-time" element={<OneTime />} />
        <Route path="/accounting" element={<Accounting />} />
        <Route path="/warehouse" element={<Warehouse />} />
        <Route path="/production" element={<Production />} />
        {canAccess('sources') && <Route path="/sources" element={<Sources />} />}
        {canAccess('settings') && <Route path="/settings" element={<Settings />} />}
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/bankaccounts" element={<BankAccounts />} />
        <Route path="/aichat" element={<AIChat />} />
        <Route path="/tariffs" element={<Tariffs />} />
        <Route path="/feedback" element={<Feedback />} />
      </Routes>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          style={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            width: 48,
            height: 48,
            borderRadius: '50%',
            background: '#F7DE8A',
            color: '#0F172A',
            border: '2px solid #8A6636',
            cursor: 'pointer',
            fontSize: 20,
            fontWeight: 700,
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            zIndex: 1000,
            transition: 'all 0.3s',
          }}
          title="Наверх"
        >
          ↑
        </button>
      )}

      <style>{`
        @media (max-width: 768px) {
          .hamburger {
            display: block !important;
          }
          header {
            flex-direction: column;
            align-items: flex-start !important;
          }
          header input {
            width: 100% !important;
          }
          nav {
            display: ${menuOpen ? 'flex' : 'none'} !important;
            flex-direction: column;
          }
          nav a {
            width: 100%;
            text-align: center;
          }
        }
        @media (min-width: 769px) {
          .hamburger {
            display: none !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Dashboard;